export const FONT_SIZES = [
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "24px",
  "28px",
  "32px",
  "36px",
  "48px",
];

export const FONT_FAMILIES = [
  { name: "Default", value: "" },
  { name: "Arial", value: "Arial, Helvetica, sans-serif" },
  { name: "Times New Roman", value: "'Times New Roman', Times, serif" },
  { name: "Georgia", value: "Georgia, serif" },
  { name: "Courier New", value: "'Courier New', Courier, monospace" },
  { name: "Verdana", value: "Verdana, Geneva, sans-serif" },
  { name: "Tahoma", value: "Tahoma, Geneva, sans-serif" },
  { name: "Trebuchet MS", value: "'Trebuchet MS', Helvetica, sans-serif" },
  { name: "Roboto", value: "Roboto, Arial, sans-serif" },
  { name: "Open Sans", value: "'Open Sans', Arial, sans-serif" },
  {
    name: "Noto Sans Bengali",
    value:
      "'Noto Sans Bengali', 'Noto Sans Bengali UI', 'Noto Sans', sans-serif",
  },
  {
    name: "SolaimanLipi",
    value: "'SolaimanLipi', 'Noto Sans Bengali', 'Noto Sans', sans-serif",
  },
  {
    name: "Siyam Rupali",
    value: "'Siyam Rupali', 'Noto Sans Bengali', 'Noto Sans', sans-serif",
  },
  {
    name: "Kalpurush",
    value: "'Kalpurush', 'Noto Sans Bengali', 'Noto Sans', sans-serif",
  },
  {
    name: "Nikosh",
    value: "'Nikosh', 'Noto Sans Bengali', 'Noto Sans', sans-serif",
  },
];

// Heading levels for the editor
export const HEADING_LEVELS = [1, 2, 3, 4, 5, 6];

// Default image dimensions
export const DEFAULT_IMAGE_WIDTH = "500px";
export const DEFAULT_IMAGE_HEIGHT = "auto";

// Default YouTube dimensions
export const DEFAULT_YOUTUBE_WIDTH = "640px";
export const DEFAULT_YOUTUBE_HEIGHT = "360px";

// Mobile breakpoint
export const MOBILE_BREAKPOINT = 768;
